<div class="supplier-wrapper">

    <h2>Add Supplier </h2>
    <table class="form-section">
      <tr>
        <td> Supplier ID: </td>
        <td> <input type="text" class="input input-sm" [(ngModel)]="newSupplier.supplierID"> </td>
      </tr>
      <tr>
        <td> Supplier Name: </td>
        <td> <input type="text" class="input input-sm" [(ngModel)]="newSupplier.companyName"> </td>
      </tr>
      <tr>
        <td> Supplier Email: </td>
        <td> <input type="text" class="input input-sm" [(ngModel)]="newSupplier.email"> </td>
      </tr>
      <tr>
        <td> Flanders Vendor Number: </td>
        <td> <input type="text" class="input input-sm" [(ngModel)]="newSupplier.flandersVN"> </td>
      </tr>
      <tr>
        <td> Swords Vendor Number: </td>
        <td> <input type="text" class="input input-sm" [(ngModel)]="newSupplier.swordsVN"> </td>
      </tr>
      <tr>
        <td> Llanberis Vendor Number: </td>
        <td> <input type="text" class="input input-sm" [(ngModel)]="newSupplier.llanberisVN"> </td>
      </tr>
      <tr>
        <td> Los Angeles Vendor Number: </td>
        <td> <input type="text" class="input input-sm" [(ngModel)]="newSupplier.lasAngelesVN"> </td>
      </tr>
    </table>


    <mat-dialog-actions>
      <button id="cancel-button" class="button button-cancel" (click)="cancel()"> Cancel </button>
        <span class="gutter"></span>
      <button id="submit-button" class="button button-submit" (click)="submit()"> Submit </button>
    </mat-dialog-actions>

</div>
